import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-xAccount-logo",
  "use": "icon-xAccount-logo-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-xAccount-logo\">\n  <defs>\n    <style>\n      #icon-xAccount-logo .cls-1 {\n        fill: #d0a972;\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-xAccount-logo_钱包\" class=\"cls-1\" d=\"M3970,843a24,24,0,1,1,24-24A24,24,0,0,1,3970,843Zm0-45a21,21,0,1,0,21,21A21,21,0,0,0,3970,798Zm5.77,35h-11.53a8.239,8.239,0,0,1-8.24-8.236V813.235a8.238,8.238,0,0,1,8.24-8.235h11.53a8.236,8.236,0,0,1,8.23,8.235v1.647h-11.12a4.53,4.53,0,1,0,0,9.059H3984v0.823A8.237,8.237,0,0,1,3975.77,833ZM3970,819.412a2.882,2.882,0,0,1,2.88-2.883H3984v5.765h-11.12A2.881,2.881,0,0,1,3970,819.412Zm4.12,0a1.235,1.235,0,1,0-1.24,1.235A1.241,1.241,0,0,0,3974.12,819.412Z\" transform=\"translate(-3946 -795)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-xAccount-logo.svg
// module id = +M6z
// module chunks = 37